/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../_helpers'
import { productsService } from '../../_services/products.service'
import _ from 'lodash'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'
import Step2 from './Step2'

import { AiOutlineLoading, AiOutlineSave } from 'react-icons/ai'

const initialRelatedProducts = [
  {
    index: 0,
    unitType: 4,
    relatedProductType: 1,
    relatedProductId: undefined,
    relatedProduct: {
      category: {
        categoryType: 1,
        id: '15781e6d-8db9-46b0-3926-08d7c03447ab'
      }
    }
  },
  {
    index: 1,
    unitType: 6,
    relatedProductType: 1,
    relatedProductId: undefined,
    relatedProduct: {
      // relatedProductId: "00000000-0000-0000-0000-000000000000",
      category: {
        categoryType: 1,
        id: '440cf54a-cef4-4ce8-74b2-08d7d033e7fb'
      }
      // brand: {
      //   id: "7763e6ca-87d3-401b-07ad-08d7c8ba7cf1",
      // }
    }
  },
  {
    index: 2,
    unitType: 7,
    relatedProductType: 0,
    relatedProductId: undefined,
    relatedProduct: {
      category: {
        categoryType: 1,
        id: '647d478f-aa12-44d3-904c-08d7c8a89a3c'
      }
    }
  },
  {
    index: 3,
    unitType: 7,
    relatedProductType: 0,
    relatedProductId: undefined,
    relatedProduct: {
      category: {
        categoryType: 1,
        id: '647d478f-aa12-44d3-904c-08d7c8a89a3c'
      },
      brand: {
        id: '7763e6ca-87d3-401b-07ad-08d7c8ba7cf1'
      }
    }
  },
  {
    index: 4,
    unitType: 7,
    relatedProductType: 1,
    relatedProductId: undefined,
    relatedProduct: {
      category: {
        categoryType: 2
      }
    }
  }
]

class Form extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: false,
      key: 'info',
      id: this.props.id,
      isGradeTwo: false,
      data: {
        name: '',
        categoryId: '',
        brandId: '',
        extraCode: '',
        quantity: 0,
        price: '',
        description: '',
        conversionUnit: '',
        measurementType: '',
        numberOfParts: 0,

        relatedProducts: initialRelatedProducts
      }
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    const { id } = this.state

    if (id) {
      let data = {}
      initialRelatedProducts.forEach(item => {
        item['relatedProductId'] = undefined
      })
      data['relatedProducts'] = initialRelatedProducts

      this.setState({ loading: true })

      await productsService
        .getById(id)
        .then(res => {
          console.log(res.data)

          data = res.data
          if (!data.relatedProducts || data.relatedProducts.length === 0) {
            data['relatedProducts'] = initialRelatedProducts
          }

          if (
            data.categoryId === '2f04bd46-c365-4320-3bcf-08d7cb2bcfeb' ||
            data.categoryId === 'c8374e6c-8809-46b6-d2b6-08d7cb2e9469'
          ) {
            var rp = data.relatedProducts
            rp = rp.filter(el => el.index !== 4)
            data['relatedProducts'] = rp
            this.setState({ isGradeTwo: true })
          }

          // for (let index = 0; index < 5; index++) {
          //   if (!data.relatedProducts[index]) {
          //     data.relatedProducts[index]["relatedProductId"] = "";
          //   }

          // }

          console.log(data)
          this.setState({ data: data, loading: false })
        })
        .catch(error => {
          // console.log(error);

          this.setState({ loading: false })
        })
    }
  }

  handleSubmit = (values, setSubmitting) => {
    this.setState({ loading: true })
    console.log(values)

    if (values.id) {
      let rp = values.relatedProducts
      if (rp[4] === undefined) {
        let obj = {
          index: 4,
          relatedProductId: undefined
        }
        rp.push(obj)
        values['relatedProducts'] = rp
      }

      console.log(values.relatedProducts)

      productsService
        .edit(values.id, JSON.stringify(values))
        .then(res => {
          if (res.data === 99) {
            let msg = `قبلا کالایی با کد [${values.extraCode}] ایجاد شده است`
            toastr.warning(msg)
          } else {
            toastr.success(
              'ویرایش کالا',
              'کالا "' + values.name + '" با موفقیت ویرایش شد'
            )
            history.push('/admin/products')
          }
          setSubmitting(false)

          let data = this.state.data
          data['relatedProducts'] = initialRelatedProducts
          this.setState({ data: data }, () => {
            this.props.onClose()
          })
        })
        .catch(error => {
          setSubmitting(false)
        })
    } else {
      productsService
        .add(JSON.stringify(values))
        .then(res => {
          // console.log(res);
          if (res.data === 99) {
            let msg = `قبلا کالایی با کد [${values.extraCode}] ایجاد شده است`
            toastr.warning(msg)
          } else {
            toastr.success(
              'ثبت کالا جدید',
              'کالا جدید  "' + values.name + '" با موفقیت ثبت شد'
            )

            this.props.onClose()
          }

          this.setState({ loading: false })
          setSubmitting(false)

          // this.props.onClose()
        })
        .catch(error => {
          // console.log(error)
          setSubmitting(false)
        })
    }
  }

  handleError(error) {
    this.setState({ loading: false })
    // toastr.warning('مشکلی پیش آمد', error);
  }


  // validateForm = (errors) => {
  //   if (Object.keys(errors).length > 0) {
  //     // // console.log(errors)
  //     let obj = errors
  //     let { createdDate, workStartDate, firstName, lastName, codeMeli, idnumber, birthDate, cellNumber, address, travelBrandId, gender, degree, childrenCount,
  //       driverDocuments,
  //       user
  //     } = obj;
  //     if (createdDate || workStartDate || firstName || lastName || codeMeli || idnumber || birthDate || cellNumber || address || travelBrandId || gender || degree || childrenCount) {
  //       this.setState({ key: "info" })
  //     } else if (driverDocuments) {
  //       this.setState({ key: "images" })
  //     }
  //   }
  // }

  render() {
    const { data, isGradeTwo } = this.state
    const { categoryType } = this.props

    const isGradeTwoItem = Yup.object().test(
      'Related Product',
      'محصول مرتبط',
      function (value) {
        // console.log(value);

        var res = false

        if (value.index < 4 && value.relatedProductId !== undefined) {
          res = true
        }

        return res
      }
    )

    const item = Yup.object().shape({
      relatedProductId: Yup.string()
        .trim()
        .nullable()
        .required('محصول مرتبط')
      // productId: Yup.string().trim().nullable().required('محصول')
    })

    const ValidationSchema = Yup.object().shape({
      name: Yup.string()
        .trim()
        .required('نام کالا'),
      categoryId: Yup.string()
        .trim()
        .required('دسته بندی'),
      brandId: Yup.string()
        .trim()
        .required('برند'),
      extraCode: Yup.string()
        .trim()
        .required('کد کالا'),
      // quantity: Yup.string().trim().required('موجودی'),
      // conversionUnit: Yup.string().trim().required('ضریب تبدیل'),
      measurementType: Yup.string()
        .trim()
        .required('واحد اصلی'),
      numberOfParts: Yup.string()
        .trim()
        .required('تعداد تایل'),

      relatedProducts:
        categoryType === 2 &&
          (data.categoryId == 'd2e9c8ca-58e6-4c1f-b230-2a15a9a8bc39' ||
            data.categoryId == '898bbcaa-daa6-4b04-b1f9-5e4172016efd')
          ? isGradeTwo
            ? Yup.array().of(isGradeTwoItem)
            : Yup.array()
              .of(item)
              .min(5, 'تمامی اطلاعات')
              .required('تمامی اطلاعات محصول')
          : ''

      // relatedProductId: categoryType > 0 && Yup.string().trim().required(categoryType === 2 ? 'ورق پرس شده مرتبط' : 'کالای مرتبط'),

      // subMeasurementType: Yup.string().trim().required('واحی فرعی'),
      // description: Yup.string().trim().required('توضیحات'),
    })

    // return <a onClick={() => postData()}>add 100 to 1000</a>
    return (

      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true)
          this.handleSubmit(values, setSubmitting)
        }}
        validationSchema={ValidationSchema}>
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm
          } = props
          return (
            <div>
              <div className="row" style={{ position: 'relative' }}>
                <form onSubmit={handleSubmit}>
                  <button
                    type="submit"
                    className={
                      'icon button submit-btn ' +
                      (isSubmitting ? 'isSubmitting' : '')
                    }
                    disabled={isSubmitting}
                    onClick={() =>
                      validateForm().then(errors => {
                        console.log(errors)
                      })
                    }>
                    {isSubmitting ? (
                      <AiOutlineLoading className="mdi-spin" size="22px" />
                    ) : (
                      <AiOutlineSave size="22px" />
                    )}
                    ذخیره
                  </button>
                  <Tabs
                    transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}>
                    <Tab eventKey="info" title="اطلاعات کالا">
                      <Step1
                        {...props}
                        categoryType={this.props.categoryType}
                        initialRelatedProducts={initialRelatedProducts}
                        isGradeTwo={isGradeTwo}
                        onChangeIsGraseTwo={val => {
                          this.setState({ isGradeTwo: val })
                          console.log(val)
                        }}
                      />
                    </Tab>
                    <Tab eventKey="images" title="تصاویر" disabled={!values.id}>
                      <Step2 {...props} />
                    </Tab>
                  </Tabs>
                </form>
              </div>
              {this.state.loading ? <Loading /> : ''}
            </div>
          )
        }}
      </Formik>
    )
  }
}

export default Form

// async function postData() {
//   const url = 'https://pl2api.amiranplus.ir/api/v1/Products/';

//   for (let i = 100; i <= 1000; i++) {
//     try {
//       var p = {
//         "name": `کد ${i}`,
//         "categoryId": "6c28e8b0-2457-41dd-ab34-42e74bc73705",
//         "brandId": "86951a56-a5f6-41f1-934e-9f2dac6ce23e",
//         "extraCode": `${i}`,
//         "quantity": 0,
//         "price": "",
//         "description": "",
//         "conversionUnit": "3.1242",
//         "numberOfParts": 0,
//         "shortExtraCode": `${i}`,
//         "measurementType": 0,
//         "subMeasurementType": 3
//       }

//       const response = await fetch(url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9lbWFpbGFkZHJlc3MiOiJhZG1pbkBhbWlyYW5wbHVzIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbW9iaWxlcGhvbmUiOiIwIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvYXV0aGVudGljYXRpb24iOiIyZGQwNTVkYi03MDVhLTQ3NDYtOTk0Mi00ZWUxZWMyOTAwNjciLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJTdXBlckFkbWluIiwibmJmIjoxNjc5NjI3ODQ1LCJleHAiOjIxMTE2Mjc4NDUsImlzcyI6Imh0dHBzOi8vbG9jYWxob3N0OjQ5OTk0LyJ9.-KIQ3N5A6z8dB_FbhhEG8scj3PIT7cZT_l9ZNhb_WuY'
//         },
//         body: JSON.stringify(p)
//       });

//       const data = await response.json();

//       console.log(`Successfully posted number ${i}: `, data);
//     } catch (error) {
//       console.error(`Error posting number ${i}: `, error);
//     }
//   }
// }
